import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltipIcon: {
      color: theme.gray500,
      opacity: 1,
      width: "18px",
      height: "18px",
    },
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
    tooltipContent: {
      color: theme.gray500,
      fontSize: 12,
      lineHeight: "20px",
      marginTop: theme.spacing(2),
    },
    exportTypeCell: {
      display: "flex",
      alignItems: "center",
      "& > svg": {
        marginRight: theme.spacing(5),
      },
      "& > p": {
        fontSize: 14,
        lineHeight: "20px",
      },
    },
    snackbar: {
      "& > div": {
        backgroundColor: theme.primary800,
      },
    },
    snackbarButton: {
      backgroundColor: theme.primary700,
      color: theme.white50,
      textDecoration: "underline",
      marginRight: theme.spacing(8),
      fontSize: 13,
      "&:hover": {
        backgroundColor: theme.primary700,
        textDecoration: "underline",
      },
    },
    tooltipFilter: {
      display: "block",
    },
  }),
);
